<template>
<main-content>
    <kt-panel>
        <kt-panel-body>
            <payman-form v-if="status !== 'loading'" :form_data="form_data" :submit="submit"></payman-form>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import PaymanForm from './components/form'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { paymanService } from '@/common/api.service'
import { mapGetters } from 'vuex'

export default {
    components: {
        mainContent,
        PaymanForm
    },
    computed: {
        ...mapGetters('payman', [
            'form_data', 'status'
        ])
    },
    data() {
        return {
            'hashid': this.$route.params.hashid
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('payman/find', vm.hashid)
        })
    },
    methods: {
        submit(e) {
            this.form_data.merchant_share_percent = $('#merchant_wage').val()
            let form = $('#payman_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    category_code: {
                        required: true,
                    },
                    address: {
                        required: true,
                    },
                    phone_number: {
                        required: true
                    },
                    logo: {
                    },
                    sheba_number: {
                        required: true
                    },
                    merchant_share_percent: {
                        required: true
                    },
                    website_address: {
                        required: true,
                        url: true
                    },
                    server_ip: {
                        required: true,
                    }
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)


            let params = this.$store.getters['payman/form_data']
            // let form_data = new FormData
            paymanService.update(this.hashid, params).then(response => {
                this.$store.commit('payman/clearFormData')
                this.$router.push('/gateways')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
}
</script>

<style>

</style>